(function () {
  var root = document.documentElement;
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;
  var addTimers = new WeakMap();

  root.classList.add('js');

  try {
    if (sessionStorage.getItem('mavelle:navigating') === '1') {
      sessionStorage.removeItem('mavelle:navigating');
      root.classList.add('mavelle-navigation-complete');
      window.setTimeout(function () {
        root.classList.remove('mavelle-navigation-complete');
      }, 400);
    }
  } catch (error) {
    // Navigation feedback still works when session storage is unavailable.
  }

  function inEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function show(target) {
    target.classList.add('is-in');
  }

  function addRevealTarget(target, targets) {
    if (!target || target.classList.contains('reveal')) return;
    target.classList.add('reveal');
    targets.push(target);
  }

  function collectRevealTargets(scope) {
    var context = scope || document;
    var targets = [];

    context.querySelectorAll('product-card').forEach(function (card) {
      addRevealTarget(card.closest('.resource-list__item') || card, targets);
    });

    context
      .querySelectorAll('.ww-routine__intro, .ww-routine__card, .ww-real-life__intro, .ww-real-life__video')
      .forEach(function (block) {
        addRevealTarget(block, targets);
      });

    context.querySelectorAll('.section-content-wrapper').forEach(function (wrapper) {
      var image = wrapper.querySelector(':scope > .image-block');
      if (!image) return;
      addRevealTarget(wrapper.querySelector(':scope > .group-block'), targets);
      addRevealTarget(image, targets);
    });

    context.querySelectorAll('h2').forEach(function (heading) {
      if (!heading.closest('#MainContent')) return;
      if (heading.closest('.mavelle-hero, [id$="__custom_liquid_hr9XMM"], .reveal')) return;
      addRevealTarget(heading, targets);
    });

    return targets;
  }

  function setCardDelays(scope) {
    var context = scope || document;
    var cards = Array.from(context.querySelectorAll('.resource-list__item.reveal, product-card.reveal'));
    var groups = new Map();

    cards.forEach(function (card) {
      var parent = card.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(card);
    });

    groups.forEach(function (group, parent) {
      var computed = window.getComputedStyle(parent);
      var columns = computed.display === 'grid' ? computed.gridTemplateColumns.split(' ').filter(Boolean).length : 1;
      var staggerCount = Math.max(1, Math.min(columns, 4));

      group.forEach(function (card, index) {
        card.style.setProperty('--i', String(index % staggerCount));
      });
    });
  }

  function observeAll(scope) {
    var targets = collectRevealTargets(scope);
    setCardDelays(scope);

    if (!targets.length) return;

    if (inEditor() || motionQuery.matches || !('IntersectionObserver' in window)) {
      targets.forEach(show);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            show(entry.target);
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );
    }

    targets.forEach(function (target) {
      revealObserver.observe(target);
    });
  }

  function prepareProductImages(scope) {
    var context = scope || document;
    context
      .querySelectorAll('main[data-template*="product"] .product-media__image')
      .forEach(function (image) {
        if (image.complete && image.naturalWidth > 0) {
          image.classList.add('is-loaded');
          return;
        }

        image.addEventListener(
          'load',
          function () {
            image.classList.add('is-loaded');
          },
          { once: true }
        );
      });
  }

  function loadRealLifeVideo(button) {
    if (!button || button.dataset.loaded === 'true') return;

    var videoId = button.dataset.videoId;
    if (!videoId) return;

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    iframe.title = button.dataset.videoTitle || 'Mavelle video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.dataset.videoType = 'youtube';
    button.replaceWith(iframe);
  }

  function isInternalNavigation(link, event) {
    if (!link || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;

    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;

    return true;
  }

  function startNavigationFeedback(event) {
    var link = event.target.closest('a[href]');
    if (!isInternalNavigation(link, event)) return;

    root.classList.add('mavelle-navigating');
    try {
      sessionStorage.setItem('mavelle:navigating', '1');
    } catch (error) {
      // The current-page progress bar does not depend on session storage.
    }
  }

  document.addEventListener('click', function (event) {
    var poster = event.target.closest('.ww-real-life__poster');
    if (poster) loadRealLifeVideo(poster);
  });

  function findAddedButtons(event) {
    var source = event.target instanceof Element ? event.target.closest('product-form-component') : null;
    if (!source) return [];

    return Array.from(source.querySelectorAll('button.add-to-cart-button, button.quick-add__button')).filter(function (
      button
    ) {
      return !button.disabled && !button.classList.contains('quick-add__button--choose');
    });
  }

  function showAddedState(button) {
    var label = button.querySelector('.add-to-cart-text__content > span > span');
    if (!label) return;

    var previousTimer = addTimers.get(button);
    if (previousTimer) window.clearTimeout(previousTimer);

    if (!button.dataset.mavelleOriginalLabel) {
      button.dataset.mavelleOriginalLabel = label.textContent.trim();
    }

    button.removeAttribute('data-added');
    button.classList.add('is-mavelle-added');
    label.textContent = 'Added \u2713';

    var timer = window.setTimeout(function () {
      label.textContent = button.dataset.mavelleOriginalLabel || 'Add to cart';
      button.classList.remove('is-mavelle-added');
      delete button.dataset.mavelleOriginalLabel;
      addTimers.delete(button);
    }, 1200);

    addTimers.set(button, timer);
  }

  function bumpCart() {
    var cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon) return;

    cartIcon.classList.remove('mavelle-cart-bump');
    window.requestAnimationFrame(function () {
      cartIcon.classList.add('mavelle-cart-bump');
      window.setTimeout(function () {
        cartIcon.classList.remove('mavelle-cart-bump');
      }, 220);
    });
  }

  function handleCartUpdate(event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.didError || data.source !== 'product-form-component') return;

    findAddedButtons(event).forEach(showAddedState);
    if (!motionQuery.matches) bumpCart();
  }

  function initialize(scope) {
    prepareProductImages(scope);
    observeAll(scope);
  }

  document.addEventListener('click', startNavigationFeedback, true);
  document.addEventListener('cart:update', handleCartUpdate);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }
})();
